angular.module('unica_invitation_list.invitation_list_services')

.factory('GrandPrixComunicateService', function ($http, $window, getBaseApiURL) {

	var grandPrixComunicateService = {};

	grandPrixComunicateService.updateGPPreinvitation = function (eventData) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-list/update-dem-gp-preinvitation/' + eventData.id,
			data: eventData
		}).then(function(result) {

			if ( result ) {
				return result.data.event;
			}

		});
	};

	grandPrixComunicateService.previewGPPreinvitation = function (id, userId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-list/preview-dem-gp-preinvitation/' + id,
			data: {
				user_id: userId
			}
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};


	grandPrixComunicateService.updateGPApproved = function (eventData) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-list/update-dem-gp-approved/' + eventData.id,
			data: eventData
		}).then(function(result) {

			if ( result ) {
				return result.data.event;
			}

		});
	};

	grandPrixComunicateService.previewGPApproved = function (id, userId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-list/preview-dem-gp-approved/' + id,
			data: {
				user_id: userId
			}
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};



	grandPrixComunicateService.updateGPDeclined = function (eventData) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-list/update-dem-gp-declined/' + eventData.id,
			data: eventData
		}).then(function(result) {

			if ( result ) {
				return result.data.event;
			}

		});
	};

	grandPrixComunicateService.previewGPDeclined = function (id, userId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-list/preview-dem-gp-declined/' + id,
			data: {
				user_id: userId
			}
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};


	return grandPrixComunicateService;
});